import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThingsComponent } from './things.component';
import {SharedModule} from '../shared/shared.module';
import {AppTranslateModule} from '../core/translate/translate.module';
import {ThingsRoutingModule, ROUTED_COMPONENTS} from './things.routing.module';
import {ThingsFormComponent} from './things-form.component';
import {ThingsCommonHeaderComponent} from './shared/wizard/wiz-cmn-header';
import {ReactiveFormsModule} from '@angular/forms';
import {ThingsService} from './things.service';
import { ThingsDetailsComponent } from './things-details/things-details.component';
import {SchemaModule} from '../schema/schema.module';
import {ConfirmPopoverModule} from '../shared/confirmpopover/confirm.pop.module';
import { EventSimulationComponent } from './things-details/event-simulation/event-simulation.component';
import {DynamicFormComponent} from "./things-details/event-simulation/dynamic-form/dynamic-form";
import {EventFormService} from "./things-details/event-simulation/event-form.service";
import {QrCodeComponent} from "./onboard/qr-code";
import {DropDownButton} from "./things-list/dropdown-button.directive";
import { EventVisualComponent } from './things-details/event-visual/event-visual.component';
import {AttributeNameFilter} from "./things-details/event-visual/attributeNameFilter";
import {AgmCoreModule} from "@agm/core";
import {ChartModule} from "angular2-highcharts";
import { HighchartsStatic } from 'angular2-highcharts/dist/HighchartsService';
import {ConnectionListComponent} from "./shared/connection-list/connection-list.component";
declare var require: any;
export function highchartsFactory() {
  const hc = require('highcharts');
  hc.setOptions({
    global: {
      useUTC: false
    }
  });

  const dd = require('highcharts/modules/drilldown');
  dd(hc);

  return hc;
}


@NgModule({
  imports: [
    CommonModule,
    ThingsRoutingModule,
    SharedModule,
    AppTranslateModule,
    ReactiveFormsModule,
    SchemaModule,
    ConfirmPopoverModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDJ5Nob2LWzXN3kSAAcFn3VlJ4XOct8RrM'
    }),
    ChartModule




  ],
  declarations: [
    ThingsComponent,
    ThingsFormComponent,
    ThingsCommonHeaderComponent,
    ROUTED_COMPONENTS,
    ThingsDetailsComponent,
    EventSimulationComponent,
    DynamicFormComponent,
    QrCodeComponent,
    DropDownButton,
    EventVisualComponent,
    AttributeNameFilter,
    ConnectionListComponent
  ],
  providers: [
    ThingsService,
    EventFormService,
    {
      provide: HighchartsStatic,
      useFactory: highchartsFactory
    }
  ],

  exports: []
})
export class ThingsModule { }



// WEBPACK FOOTER //
// ./src/app/things/things.module.ts